const ITEMS = [
    "Advanced Yogasana",
    "Competition Training",
    "Gold Medalist",
    "World Record Holder",
    "National Yoga Coach",
    "Strength ✦ Flexibility ✦ Focus",
];

function Row({ hidden }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-2xl tracking-[0.14em] text-white/75 sm:text-3xl">
                        {item}
                    </span>
                    <span className="text-lg text-[#D4A017]">✦</span>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="relative overflow-hidden border-y border-[#D4A017]/15 bg-[#090909] py-5">
            <div className="animate-marquee flex w-max">
                <Row />
                <Row hidden />
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050505] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050505] to-transparent" />
        </div>
    );
}
